import { AnalyticsActions } from './types';
import { API } from '../../../vendor/api';
import { selectInstitution } from '../system';
export const mapState = ({ payload }) => async (dispatch) => {
    dispatch({ type: AnalyticsActions.GET_ANALYTICS, payload });
};
export const getAnalyticsAPI = ({ providersIds, roomsIds, locationIds, }) => async (dispatch, getState) => {
    try {
        const institution = selectInstitution(getState());
        const institutionId = institution ? institution.id : null;
        const analytics = await API.analytics.getAnalytics({
            institutionId,
            userIds: providersIds,
            roomIds: roomsIds,
            locationIds: locationIds,
        });
        dispatch({
            type: AnalyticsActions.GET_ANALYTICS,
            payload: analytics,
        });
    }
    catch (e) {
        console.error('Error in action "getAnalyticsById": ', e);
    }
};
export const getAnalyticsOverviewAPI = ({ start, end, providersIds, roomsIds, locationIds, }) => async (dispatch, getState) => {
    try {
        const institution = selectInstitution(getState());
        let institutionId = null;
        if (institution) {
            institutionId = institution.id;
        }
        const analytics = await API.analytics.getAnalyticsOverview({
            institutionId,
            userIds: providersIds,
            roomIds: roomsIds,
            locationIds: locationIds,
            start,
            end,
        });
        dispatch({
            type: AnalyticsActions.GET_ANALYTICS_HEADER,
            payload: analytics,
        });
    }
    catch (e) {
        console.error('Error in action "getAnalyticsOverview": ', e);
    }
};
export const setAnalyticsFilter = ({ providersIds, roomsIds, locationIds, }) => async (dispatch, getState) => {
    dispatch({
        type: AnalyticsActions.SET_ANALYTICS_FILTER,
        payload: {
            providersIds,
            roomsIds,
            locationIds,
        },
    });
};
export const setAnalyticsDatePeriod = (datePeriod) => async (dispatch, getState) => {
    dispatch({
        type: AnalyticsActions.SET_ANALYTICS_DATE_PERIOD,
        payload: datePeriod,
    });
};
